import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface StoreTabSearch {
  companyCode: string;
  tradeName: string;
  cpid: string;
  businessCode: string;
  shopCode: string;
  storeName: string;
  timestamp: number;
}

const initialState = {} as StoreTabSearch;

const searchStore = createSlice({
  name: "merchant-info-inquiry",
  initialState,
  reducers: {
    createSearchCondition: (state, action: PayloadAction<StoreTabSearch>) => {
      const {
        companyCode,
        cpid,
        businessCode,
        shopCode,
        tradeName,
        storeName,
        timestamp,
      } = action.payload;
      state.companyCode = companyCode;
      state.cpid = cpid;
      state.businessCode = businessCode;
      state.shopCode = shopCode;
      state.tradeName = tradeName;
      state.storeName = storeName;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } = searchStore.actions;

export default searchStore.reducer;
